module.exports = __webpack_public_path__ + "static/media/ic_arrow_up.c12c3bdd.svg";